import {Injectable} from "../../helpers";

export class AppPropertyFilterService extends Injectable {

    setProperty(property) {

        this.property = property;

        return this;
    }

    getProperty() {

        return this.property;
    }

    clearProperty() {

        this.property = null;
    }

    setPermissions(permissions) {

        this.permissions = permissions;

        return this;
    }

    getPermissions() {

        return this.permissions;
    }

    clearPermissions() {

        return this.permissions = null;
    }

    clear() {

        this.clearProperty();
        this.clearPermissions();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/property-filter.service.js